import React from 'react';

const ColorSetter = (props) => {
  // component logic
  const style = {
    '--main-color-set': props.colors.mainColor,
    '--accent-color-set': props.colors.accentColor,
    '--main-text-color-set': props.colors.mainTextColor,
    '--title-color-set': props.colors.titleColor,
    '--background-color-set': props.colors.backgroundColor,
    '--side-nav-color-set': props.colors.sideNavColor,
    '--side-nav-text-color-set': props.colors.sideNavTextColor,
    '--header-color-set': props.colors.headerColor,
    '--header-text-color-set': props.colors.headerTextColor,
    '--panel-color-set': props.colors.panelColor
  }
  
  // execute the return function/method
  return (
    <div style={style}>
      {props.children}
    </div>
  );
};

export default ColorSetter;